import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.surveys)

export const SURVEYS_INSTANCE = service.instanceKey

export const SURVEYS_ENDPOINTS = {
  SELECT:         "/employee/surveys/select",
  VIEW_DETAIL:    "/employee/surveys/view/detail",
  SAVE_RESPONSE:  "/survey/save_response",
  SUBMIT:         "/survey/submit",
  VIEW_INDEX:     "/survey/view/index",
  NOTIFICATIONS:  "/employee/notifications/select",
} as const

export const surveysService = {
  instanceKey: service.instanceKey,

  select:          (params?: Record<string, any>) =>
    service.get(SURVEYS_ENDPOINTS.SELECT, params),
  viewDetail:      (id: string | number) =>
    service.get(`${SURVEYS_ENDPOINTS.VIEW_DETAIL}?id=${id}`),
  saveResponse:    (params: {
    survey_id: string | number
    question_id: string | number
    response: string
    type: string
  }) =>
    service.post(
      `${SURVEYS_ENDPOINTS.SAVE_RESPONSE}?${new URLSearchParams({
        survey_id: String(params.survey_id),
        question_id: String(params.question_id),
        response: params.response,
        type: params.type,
      }).toString()}`
    ),
  viewIndex:       (id: string, code: string) =>
    service.get(SURVEYS_ENDPOINTS.VIEW_INDEX, { id, code }),
  submit:          (surveyId: string | number) =>
    service.post(`${SURVEYS_ENDPOINTS.SUBMIT}?survey_id=${surveyId}`),
  getNotifications: (params?: { pageNumber?: number; pageSize?: number }) =>
    service.get(SURVEYS_ENDPOINTS.NOTIFICATIONS, params),
}
